/* eslint-disable max-statements */
import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';
import Avatar from 'components/avatar';
import Moment from 'moment';

class WorkOrderHistory extends React.Component {
  static propTypes = {
    bindingWorkOrderHistory: PropTypes.func,
    WorkOrderHistories: PropTypes.array,
    wrapperHeight: PropTypes.any
  };

  static contextTypes = {
    t: PropTypes.func
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.bindingWorkOrderHistory();
  }

  renderCustomTerms = key => {
    const { t } = this.context;
    if (t) {
      return t(key);
    }
    return key;
  };

  renderActionDescription = item => {
    if (item.action === 1) {
      return 'created this work order.';
    } //WOCreation
    if (item.action === 2) {
      return 'edited this work order.';
    } //WOModification
    if (item.action === 3) {
      //WOStatusChanged
      const statusField = item.changedFields.find(
        field => field.fieldName === 'Status'
      );
      const newStatus = statusField ? (
        <span style={{ fontStyle: 'italic' }}>{statusField.newValue}</span>
      ) : (
        ''
      );

      if (statusField && statusField.newValue === 'Resolved') {
        const lastResolvedDate = item.changedFields.find(
          field => field.fieldName === 'LastResolvedDate'
        );

        const homeownerSignature = item.changedFields.find(
          field => field.fieldName === 'HomeOwnerSignature'
        );

        return (
          <span>
            changed status to {newStatus}.
            {lastResolvedDate &&
              ` Last resolved date was updated to ${Moment(
                lastResolvedDate.newValue
              ).format('MM/DD/YYYY')}.`}
            {homeownerSignature && ' Homeowner signature was captured.'}
          </span>
        );
      }

      if (statusField && statusField.newValue === 'Closed') {
        const lastClosedDate = item.changedFields.find(
          field => field.fieldName === 'LastClosedDate'
        );
        const lastResolvedDate = item.changedFields.find(
          field => field.fieldName === 'LastResolvedDate'
        );
        const closedReason = item.changedFields.find(
          field => field.fieldName === 'ClosedReason'
        );

        const homeownerSignature = item.changedFields.find(
          field => field.fieldName === 'HomeOwnerSignature'
        );

        return (

          <span>
            changed status to {newStatus}.
            {lastResolvedDate &&
              ` Last resolved date was updated to ${Moment(
                lastResolvedDate.newValue
              ).format('MM/DD/YYYY')}.`}
            {lastClosedDate &&
              ` Last closed date was updated to ${Moment(
                lastClosedDate.newValue
              ).format('MM/DD/YYYY')}.`}
            {homeownerSignature && ' Homeowner signature was captured.'}
            {closedReason && ` Reason was \"${closedReason.newValue}\".`}
          </span>
        );
      }

      if (statusField && statusField.newValue === 'Declined') {
        const DeclinedReason = item.changedFields.find(
          field => field.fieldName === 'DeclinedReason'
        );
        return (
          <span>
            changed status to {newStatus}.
            {DeclinedReason && ` Reason was \"${DeclinedReason.newValue}\".`}
          </span>
        );
      }

      if (statusField && statusField.newValue === 'Requested to reopen') {
        const reopenReason = item.changedFields.find(
          field => field.fieldName === 'ReopenReason'
        ).newValue;
        return (
          <span>
            changed status to {newStatus}. Reason was "{reopenReason}."
          </span>
        );
      }

      if (
        statusField &&
        statusField.newValue === 'Pending' &&
        statusField.oldValue === 'Open'
      ) {
        const holdReason = item.changedFields.find(
          field => field.fieldName === 'HoldReason'
        ).newValue;
        return (
          <span>
            changed status to {newStatus}. Reason was "{holdReason}."
          </span>
        );
      }

      return <span>changed status to {newStatus}.</span>;
    }
    if (item.action === 4) {
      //WOSendToAssignee
      const assignee = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      return `sent this work order to ${assignee}.`;
    }
    if (item.action === 5) {
      //WOResendToAssignee
      const assignee = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      return `resent this work order to ${assignee}.`;
    }
    if (item.action === 6) {
      //WOUploadAttachment
      const fileName = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      return `uploaded ${fileName}.`;
    }

    if (item.action === 9) {
      //autoGeneratePDFAttachment
      const fileName = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      return `${fileName} was automatically uploaded after the homeowner's signature is captured.`;
    }

    if (item.action === 20) {
      //POCreation
      const poRefNo = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      return `created PO#${poRefNo}.`;
    }
    if (item.action === 21) {
      //POSendToAssignee
      const poRefNo = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      const assignee = item.changedFields[1]
        ? item.changedFields[1].newValue
        : '';
      return `sent PO#${poRefNo} to ${assignee}.`;
    }
    if (item.action === 22) {
      //POResendToAssignee
      const poRefNo = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      const assignee = item.changedFields[1]
        ? item.changedFields[1].newValue
        : '';
      return `resent PO#${poRefNo} to ${assignee}.`;
    }
    if (item.action === 30) {
      //BCCreation
      const bcRefNo = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      const poRefNo = item.changedFields[1]
        ? item.changedFields[1].newValue
        : '';
      return `created BC#${bcRefNo} for PO#${poRefNo}.`;
    }
    if (item.action === 31) {
      //BCSendToAssignee
      const bcRefNo = item.changedFields[0]
        ? item.changedFields[0].newValue
        : '';
      const assignee = item.changedFields[1]
        ? item.changedFields[1].newValue
        : '';
      return `sent BC#${bcRefNo} to ${assignee}.`;
    }
    if (item.action === 40) {
      //RFSCreation
      return 'created this request.';
    }
    if (item.action === 41) {
      //RFSModification
      return 'edited this request.';
    }

    return '(Not specified)';
  };

  renderAutomat = item => {
    return (
      <div className='history-record clearfix'>
        <div className='history-content'>
          <span className='automat'>
            Status was automatically updated to "Closed" since the creator
            failed to close it.
          </span>
          <span className='date'>
            {Moment(item.createdDate).format('MM/DD/YYYY hh:mm A')}
          </span>
        </div>
      </div>
    );
  };

  renderWOAutomaticallyOpen = item => {
    return (
      <div className='history-record clearfix'>
        <div className='history-content'>
          <span className='automat'>{item.actionDescription}</span>
          <span className='date'>
            {Moment(item.createdDate).format('MM/DD/YYYY hh:mm A')}
          </span>
        </div>
      </div>
    );
  };

  renderWOAutomaticallyAssignEvent = item => {
    const assignEvent = JSON.parse(item.changedFields[0].newValue);
    const numFunction = () => {
      let numEvent = assignEvent.Order;
      if (numEvent === 2) {
        return 'nd';
      } else if (numEvent === 3) {
        return 'rd';
      } else {
        return 'th';
      }
    };
    const num = numFunction();
    const emailEvent = assignEvent.Emails.join(',  ');
    return (
      <div className= 'history-record clearfix'>
        <div className='history-content'>
          <span style={{wordBreak: 'break-word'}} className='automat'>{`The ${assignEvent.Order}${num} follow up notice was sent to ${emailEvent}`}</span>
          <span className='date'>
            {Moment(item.createdDate).format('MM/DD/YYYY hh:mm A')}
          </span>
        </div>
      </div>
    );
  }

  renderRFSAutomat = item => {
    const assignEvent = JSON.parse(item.changedFields[0].newValue);
    // const numEvent = assignEvent.Order;
    const numFunction = () => {
      let numEvent = assignEvent.Order;
      if (numEvent === 1) {
        return 'st';
      } else if (numEvent === 2) {
        return 'nd';
      } else if (numEvent === 3) {
        return 'rd';
      } else {
        return 'th';
      }
    };
    const num = numFunction();
    const emailEvent = assignEvent.Emails.join(',  ');
    return (
      <div className= 'history-record clearfix'>
        <div className='history-content'>
          <span style={{wordBreak: 'break-word'}} className='automat'>{`The ${assignEvent.Order}${num} follow up notice was sent to ${emailEvent}`}</span>
          <span className='date'>
            {Moment(item.createdDate).format('MM/DD/YYYY hh:mm A')}
          </span>
        </div>
      </div>
    );
  };

  renderOldNewValue = (fieldName, value) => {
    if (fieldName === 'AppointmentDate') {
      if (value === '' || value === null) {
        return '';
      } else {
        return Moment(value).format('MM/DD/YYYY hh:mm A');
      }
    } else if (
      fieldName === 'LastResolvedDate' ||
      fieldName === 'LastClosedDate'
    ) {
      if (value === '' || value === null) {
        return '';
      } else {
        return Moment(value).format('MM/DD/YYYY');
      }
    } else {
      return value;
    }
    // return (fieldName === 'AppointmentDate')
    //   ? Moment(value).format('MM/DD/YYYY hh:mm A')
    //   : value;
  };

  renderHistoryRecord = item => {
    if (item.action === 10) {
      //WOAutomaticallyClosed
      return this.renderAutomat(item);
    }

    if (item.action === 7) {
      //WOAutomaticallyOpen
      return this.renderWOAutomaticallyOpen(item);
    }
    if (item.action === 11) {
      return this.renderWOAutomaticallyAssignEvent(item);
    }
    if (item.action === 45) {
      return this.renderRFSAutomat(item);
    }
    if (item.action === 2 || item.action === 41) {
      //edit action
      return (
        <div className='history-record clearfix'>
          <Panel eventKey='1'>
            <Panel.Heading>
              <Panel.Title toggle>
                <div className='history-avatar'>
                  <Avatar src={null} size={32} />
                </div>
                <div className='history-content'>
                  <span className='username'>{item.actor}</span>
                  <span className='action'>
                    {this.renderActionDescription(item)}
                  </span>
                  <span className='date'>
                    {Moment(item.createdDate).format('MM/DD/YYYY [at] hh:mm A')}
                  </span>
                </div>
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
              {item.changedFields.map(field => (
                <div className='updated-detail'>
                  <div className='updated-field'>
                    {this.renderCustomTerms(field.fieldName)}
                  </div>
                  <div className='updated-content'>
                    <ul>
                      <li key='old-value'>
                        <div className='updated-header'>Old value</div>
                        <div>
                          {this.renderOldNewValue(
                            field.fieldName,
                            field.oldValue
                          )}
                        </div>
                      </li>
                      <li key='new-value'>
                        <div className='updated-header'>New value</div>
                        <div>
                          {this.renderOldNewValue(
                            field.fieldName,
                            field.newValue
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              ))}
            </Panel.Body>
          </Panel>
        </div>
      );
    }

    return (
      <div className='history-record clearfix'>
        <div className='history-avatar'>
          <Avatar src={null} size={32} />
        </div>
        <div className='history-content'>
          <span className='username'>{item.actor}</span>
          <span className='action'>{this.renderActionDescription(item)}</span>
          <span className='date'>
            {Moment(item.createdDate).format('MM/DD/YYYY [at] hh:mm A')}
          </span>
        </div>
      </div>
    );
  };

  render() {
    const { WorkOrderHistories } = this.props;
    return (
      <div
        className='work-order-history-wrapper'
        style={
          this.props.wrapperHeight ? { height: this.props.wrapperHeight } : {}
        }
      >
        {WorkOrderHistories.map(item => this.renderHistoryRecord(item))}
      </div>
    );
  }
}

export default WorkOrderHistory;



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/WorkOrderHistory.js